import { useAtom } from "jotai";
import { languageAtom } from "../store";
import { getText, type LanguageCode, type LanguageKey } from "../constants/languages";

export const useLanguage = () => {
  const [language, setLanguage] = useAtom(languageAtom);

  const t = (key: LanguageKey): string => {
    return getText(language.value as LanguageCode, key);
  };

  const changeLanguage = (newLanguage: LanguageCode) => {
    const languageOptions = [
      { label: "EN(US)", value: "en" },
      { label: "HI(IN)", value: "hi" }
    ];
    
    const selectedOption = languageOptions.find(option => option.value === newLanguage);
    if (selectedOption) {
      setLanguage(selectedOption);
    }
  };

  return {
    language: language.value as LanguageCode,
    t,
    changeLanguage,
    currentLanguageOption: language
  };
};
